import script from "./SpinnerLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&setup=true&lang=js"

import "./SpinnerLoader.vue?vue&type=style&index=0&id=40632624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40632624"]])

export default __exports__